module.exports = __webpack_public_path__ + "48c0cc0e4e328e5e5fe62f51e73aed9e.pdf";